import React from 'react';
import { BrowserRouter } from './browser-router';
import { StoreProvider } from './redux-provider';
import { ToastProvider } from './toast-provider';

export const Providers: React.FC = ({ children }) => {
    return (
        <BrowserRouter>
            <StoreProvider>
                <ToastProvider>{children}</ToastProvider>
            </StoreProvider>
        </BrowserRouter>
    );
};
